<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <MrTaskManagementToolBar :enableStatus="enableStatus" ref="mrTaskManagementToolBarForGnb"></MrTaskManagementToolBar>
      <MrTaskManagementList @enableStatusChange="enableStatusChange" ref="mrTaskManagementList"></MrTaskManagementList>

      <!-- 新增任务弹出框 -->
      <CustomDialog ref='addMeasureTaskDialog' :element='addMeasureTaskDialog.element' :styles='addMeasureTaskDialog.style'>
        <template v-slot:dialog-content>
          <AddMeasureTaskDialog ref='addMeasureTask'></AddMeasureTaskDialog>
        </template>
      </CustomDialog>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import MrTaskManagementToolBar from "../../components/mrConfig/mrTaskManagement/MrTaskManagementToolBar";
import MrTaskManagementList from "../../components/mrConfig/mrTaskManagement/MrTaskManagementList";
import CustomDialog from "../../components/common/CustomDialog";
import AddMeasureTaskDialog from "../../components/mrConfig/mrTaskManagement/dialog/AddMeasureTaskDialog";
import {EventBus} from "../../plugins/eventBus";

export default {
  name: 'MrMeasureTask',
  components: {
    BasicLayout,
    MrTaskManagementToolBar,
    MrTaskManagementList,
    CustomDialog,
    AddMeasureTaskDialog,
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('MR.mrManage')}/${this.$t("MR.mrTaskManage")}`
      },

      enableStatus: "2",

      addMeasureTaskDialog: {
        style: {
          width: '700px',
          height: '800px',
          visible: false,
          model: true
        },
        element: {
          title: this.$t('MR.addMrTask'),
          target: this.$refs.mrTaskManagementList,
          refName: 'addMeasureTaskElement',
          buttonGroup: [
            { click: this.closeAddMeasureTaskDialog, buttonModel: { content: this.$t('Common.cancel') } },
            { click: this.addMeasureTaskCommit, buttonModel: { content: this.$t('Pm.finish'), isPrimary: true } }
          ],
          isClose: true
        }
      },

    };
  },
  methods: {

    enableStatusChange(msg) {
      this.enableStatus = msg;
    },
    methodList(operator) {
      switch (operator) {
        case 'add':
          this.addTask();
          break;
        case 'enable':
          this.setTaskCommit("1");
          break;
        case 'disable':
          this.setTaskCommit("0");
          break;
        case 'delete':
          this.deleteTaskCommit();
          break;
        default:
      }
    },

    addTask(){
      this.$refs.addMeasureTask.$refs.pmGnbTopoTreeRef.getPmGnbTopoTree();
      this.$refs.addMeasureTask.bindValidateOfAddMrTask();
      this.$refs.addMeasureTaskDialog.show();
    },

    addMeasureTaskCommit() {
      const ruleDatas = this.$refs.addMeasureTask.validateOfAddMrTask();
      if (!ruleDatas) {
        return;
      }
      let neClickInfo = this.$refs.addMeasureTask.neClickInfo;
      if(neClickInfo == null || neClickInfo == undefined){
        EventBus.$emit('toast', { type: 'warning', content: this.$t('MR.pleaseSelectNE') });
        return;
      }
      const mrTaskInfo = this.$refs.addMeasureTask.getMrTaskData();
      this.$loading.showLoadding(this.$t('System.loading'));
      this.$axios.post('/lte/ems/mr/add', mrTaskInfo).then(response => {
        if(response.data.errorCode != 0 && response.data.errorCode!= 'SUCCESS' && response.data.errorCode!= 'success') {
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        }else{
          EventBus.$emit('toast', { type: 'success', content: this.$t('MR.addTaskSuccess') });
        }
        this.$refs.mrTaskManagementList.getTaskListOfMr();
      });
      this.$loading.hideLoadding();
      this.$refs.addMeasureTaskDialog.close();
    },

    setTaskCommit(status){
      const data = this.$refs.mrTaskManagementList.rowDataOfMrTask;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      this.$loading.showLoadding(this.$t('System.loading'));
      this.$axios.post('/lte/ems/mr/setMrTaskStatus.html', {
        enableStatus: status,
        alias: data.alias,
        url: '',
        username: '',
        password: '',
        measureType: data.measureType,
        omcName: data.omcName,
        samplePeriod: data.samplePeriod,
        uploadPeriod: data.uploadPeriod,
        sampleBeginTime: data.sampleBeginTime.toString(),
        sampleEndTime:  data.sampleEndTime.toString(),
        prbNum: data.prbNum,
        subFrameNum: data.subFrameNum,
        neIp: data.neIp,
        nePort: data.nePort,
        cpeId: data.neName,
        neId: data.neId,
        instanceNumber: data.instanceNumber          
      }).then(response => {
        if(response.data.errorCode != 0 && response.data.errorCode!= 'SUCCESS' && response.data.errorCode!= 'success') {
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        }else{
          EventBus.$emit('toast', { type: 'success', content: this.$t('MR.setTaskStatusSuccess') });
        }
        this.$refs.mrTaskManagementList.getTaskListOfMr();
      });
      this.$loading.hideLoadding();
    },

    closeAddMeasureTaskDialog(){
      this.$refs.addMeasureTaskDialog.close();
    },


    deleteTaskCommit(){
      const data = this.$refs.mrTaskManagementList.rowDataOfMrTask;
      if (data == null || data == '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      this.$loading.showLoadding(this.$t('System.loading'));
      this.$axios.post('/lte/ems/mr/delMrTask', {
        instanceNumber: data.instanceNumber,
        neId: data.neId,
        neIp: data.neIp,
        nePort: data.nePort,
        cpeId: data.neName
      }).then(response => {
        if(response.data.errorCode != 0 && response.data.errorCode!= 'SUCCESS' && response.data.errorCode!= 'success') {
          EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
        }else{
          EventBus.$emit('toast', { type: 'success', content: this.$t('MR.deleteTaskSuccess') });
        }
        this.$refs.mrTaskManagementList.getTaskListOfMr();
      });

      this.$loading.hideLoadding();
    }
  },
};
</script>

<style>

</style>
